<template>
  <div class="app-wrapper">
    <div class="topbarContainer">
      <topbar></topbar>
    </div>
    <div>
        <div class="sidebarContainer">
          <sidebar class="sidebar" ref="sidebar"></sidebar>
        </div>
        <contentView class="contentView"></contentView>
    </div>
  </div>
</template>
<script>
// import Navbar from './Navbar'
import sidebar from './sidebar'
import contentView from './contentView'
import topbar from './topbar'

export default {
  name: 'layout',
  components: {
    sidebar,
    contentView,
    topbar
  }
}

</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  // border-top: 1px black solid;
}

.topbarContainer {
  position: absolute;
  height: 60px;
  top: 0px;
  left:0px;
  right: 0px;
  background: linear-gradient(#ffffff, #eeeeee);
  border-top: 2px solid #81a5c9;
  border-bottom: 1px solid #e5e5e5;
  z-index: 10;
}

// .app-wrapper.hideSidebar {
//   .sidebarContainer{
//     transform: translate(-130px, 0);
//   }
//   .sidebar-container {
//     transform: translate(130px, 0);
//   }

//   .contentViewContainer {
//     margin-left: 50px;
//   }
// }

.sidebarContainer {
  transition: all 0.18s linear;
  width: 240px;
  background-color: #F6F6F6;
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow-y: auto;
  padding-top: 20px;
  

  // &::-webkit-scrollbar {
  //   display: none
  // }
}

// .contentViewContainer {
 
// }

// .contentView {
//    // min-height: calc(100vh - 50px);
//   transition: all 0.18s linear;
//   margin-left: 240px;
//   padding-left: 30px;
//   padding-top:30px;
//   padding-right: 30px;

// }

.contentView {
   // min-height: calc(100vh - 50px);
  transition: all 0.18s linear;
  position: absolute;
  left: 260px;
  right: 0px;
  top: 64px;
  bottom: 0px;
  padding-right: 30px;
  overflow-y:scroll; 
}

</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue